import BaseModule from './BaseModule'

class Rotator extends BaseModule {
	constructor(o) {
		super(o);

		this.enable();
	}

	enable() {
		super.enable()

		if (this.options.html !== undefined) {
			this.el.innerHTML = this.unrotate(this.el.innerHTML)

		}

		if(this.options.attributes !== undefined) {
			this.options.attributes.forEach(
				(attribute) => this.el.setAttribute(
					attribute,
					this.unrotate(
						this.el.getAttribute(attribute)
					)
				)
			)
		}
	}

	unrotate(rotated) {
		return rotated.replace(
			/[a-z]/gi,
			(c)=> String.fromCharCode((c<="Z"?90:122)>=(c=c.charCodeAt(0)+13)?c:c-26)
		)
	}
}

export default Rotator
